(function () {
   const viewport = document.getElementById('homeProductsViewport');
   const prevButtons = Array.from(document.querySelectorAll('[data-prod-prev]'));
   const nextButtons = Array.from(document.querySelectorAll('[data-prod-next]'));
   const dotsWrap = document.getElementById('homeProductsDots');
   const controls = dotsWrap ? dotsWrap.closest('.products__controls') : null;

   if (!viewport) return;

   // Mobile: 1 item por vez (1 step por item). Desktop: 3 itens por página.
   const MOBILE_QUERY = '(max-width: 767px)';
   const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;
   const itemsPerPage = () => (isMobile() ? 1 : 3);

   const totalCards = () => viewport.querySelectorAll('.home-prod-card').length;

   const cardMetrics = () => {
      const card = viewport.querySelector('.home-prod-card');
      const track = viewport.querySelector('.products__track');
      const gap = track ? parseFloat(window.getComputedStyle(track).gap) || 16 : 16;
      const cardW = card ? card.offsetWidth : viewport.clientWidth;
      return { cardW, gap };
   };

   // Largura de uma "página" = (card + gap) * itens por página.
   const pageWidth = () => {
      const { cardW, gap } = cardMetrics();
      return (cardW + gap) * itemsPerPage();
   };

   const maxScroll = () => viewport.scrollWidth - viewport.clientWidth;

   const pageCount = () => Math.max(1, Math.ceil(totalCards() / itemsPerPage()));

   const currentPage = () => {
      const last = pageCount() - 1;
      // Ao chegar no fim do scroll, garante o último step ativo.
      if (viewport.scrollLeft >= maxScroll() - 2) return last;
      // Passou da metade da página → vai para o próximo step.
      return Math.min(last, Math.round(viewport.scrollLeft / pageWidth()));
   };

   const scrollToPage = index => {
      const target = Math.min(index * pageWidth(), maxScroll());
      viewport.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
   };

   const scrollByStep = direction => {
      scrollToPage(currentPage() + direction);
   };

   // --- Steps (paginação) ---
   let dots = [];

   const syncDots = () => {
      const active = currentPage();
      const last = pageCount() - 1;

      // Setas desabilitadas nos extremos.
      prevButtons.forEach(btn => {
         btn.disabled = active <= 0;
      });
      nextButtons.forEach(btn => {
         btn.disabled = active >= last;
      });

      if (!dots.length) return;
      dots.forEach((dot, index) => {
         const isActive = index === active;
         dot.classList.toggle('is-active', isActive);
         dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
   };

   const buildDots = () => {
      if (!dotsWrap) return;
      const count = pageCount();

      dotsWrap.innerHTML = '';
      dots = [];

      const sideButtons = [...prevButtons, ...nextButtons].filter(btn => btn.classList.contains('products__nav--side'));

      if (count <= 1) {
         dotsWrap.hidden = true;
         if (controls) controls.hidden = true;
         sideButtons.forEach(btn => {
            btn.hidden = true;
         });
         return;
      }

      dotsWrap.hidden = false;
      if (controls) controls.hidden = false;
      sideButtons.forEach(btn => {
         btn.hidden = false;
      });

      for (let i = 0; i < count; i += 1) {
         const dot = document.createElement('button');
         dot.type = 'button';
         dot.className = 'products__dot';
         dot.setAttribute('role', 'tab');
         dot.setAttribute('aria-label', `Página ${i + 1} de ${count}`);
         dot.addEventListener('click', () => scrollToPage(i));
         dotsWrap.appendChild(dot);
         dots.push(dot);
      }

      syncDots();
   };

   prevButtons.forEach(btn => btn.addEventListener('click', () => scrollByStep(-1)));
   nextButtons.forEach(btn => btn.addEventListener('click', () => scrollByStep(1)));

   viewport.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') {
         event.preventDefault();
         scrollByStep(-1);
      }

      if (event.key === 'ArrowRight') {
         event.preventDefault();
         scrollByStep(1);
      }
   });

   let scrollRaf;
   viewport.addEventListener('scroll', () => {
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(syncDots);
   });

   let resizeTimer;
   window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildDots, 200);
   });

   buildDots();
})();
